module.exports = __webpack_public_path__ + "static/media/photo5.2dc1f4fd.jpg";